import { WAVE_APP_ID } from "@vida/wave-core";
import { getIdToken } from "../auth";

let adminApiBaseUrl: string | null = null;

export function setAdminApiBaseUrl(url: string | null | undefined): void {
  const trimmed = url?.trim().replace(/\/$/, "") ?? "";
  adminApiBaseUrl = trimmed || null;
}

export function getAdminApiBaseUrl(): string | null {
  return adminApiBaseUrl;
}

export type WaveAccountCredits = {
  balanceCents: number;
  totalGrantedCents?: number | null;
  totalSpentCents?: number | null;
};

export async function fetchWaveCredits(): Promise<WaveAccountCredits> {
  const base = adminApiBaseUrl;
  if (!base) throw new Error("admin-api non configurato.");
  const token = await getIdToken();
  const res = await fetch(`${base}/api/me/credits`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "X-Vida-AppId": WAVE_APP_ID,
    },
  });
  const text = await res.text();
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}: ${text.slice(0, 200)}`);
  }
  return JSON.parse(text) as WaveAccountCredits;
}

export function formatCreditsBalance(balanceCents: number): string {
  return `€ ${(balanceCents / 100).toFixed(2)}`;
}
